import axios from "axios";

axios.defaults.baseURL = "https://backdev.azrmelk.com/api/"


export default axios